import { parseExpressFullOdds } from "./parseFullOdds";
import { parseTopNOdds } from "./parseTopNOdds";
import { parseBankerOdds } from "./parseBankerOdds";
import{ parseWPQBanker}  from "./parseWPQBanker";
import{ parseWPQTop}  from "./parseWPQTop";

export const parseExpressOdds = ( content, message, topicInfo) => {
    let pmPool,
        poolInv;
    switch (topicInfo.displayType) {
        case "full":
            pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType && x.leg.races[0]===topicInfo.raceNo)[0];
            poolInv = content.meeting.poolInvs.find(x => x.oddsType===topicInfo.oddsType && x.leg.races[0]===topicInfo.raceNo);
            if(pmPool!=null){
                parseExpressFullOdds(pmPool,message)
            }
            if(poolInv != null){
                let investment
                if(message?.pRfd) {
                    investment = 0
                }else{
                    investment = message?.pInv || poolInv.investment
                }
                poolInv.investment = investment
            }
            //  [WIP]  WPQ page
            // if(content.page == "WPQ"){    
            //     pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType +"Top" && x.leg.races[0]===topicInfo.raceNo)[0]; //parseTop20
            //     if(pmPool!=null){
            //         parseWPQTop(pmPool,message)
            //     }
            //     pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType +"Banker" && x.leg.races[0]===topicInfo.raceNo)[0]; //parse Banker
            //     if(pmPool!=null){
            //         parseWPQBanker(pmPool,message)
            //     }
            // }
            break;
        case "top_n":
            // pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType + "Top" && x.leg.races[0]===topicInfo.raceNo)[0];
            // if(pmPool!=null){
            //     parseTopNOdds(pmPool,message)
            // }
            break;
        case "banker":
            // pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType + "Banker" && x.leg.races[0]===topicInfo.raceNo)[0];
            // if(pmPool!=null){
            //     parseBankerOdds(pmPool,message)
            // }
            break;
    }
}